import { Flex, Spin } from "antd";
import styled from "styled-components";

export const ProductCategoryWrap = styled(Flex)`
  height: 100%; 
  > .left,
  > .right {
    height: 100%;
  }

  > .left {
    > .left-tree{
      padding: 10px;
      border: 1px solid #ccc;
      overflow: auto;
      height: 86vh;
    }
  }
    > .left .left-add-but{
      margin-bottom: 10px;
      width: 100%;
    }

  > .right {
    flex: 1;
    min-width: 40%;
  }
`

export const CategoryDetailItem = styled(Flex)`
  margin-top: 10px;

  .category-detail--item-right {
    margin-left: 4px;
  }
`

export const ProductCategories = styled.div`
  min-width: 200px;
  max-width: 300px;
  margin-right: 20px;
`

export const ProductSpin = styled(Spin)`  
  height: 80vh;  
  display: flex;  
  justify-content: center;  
  align-items: center;  
`;